import { render, staticRenderFns } from "./KlasusIndex.vue?vue&type=template&id=66e65c82&scoped=true"
import script from "./KlasusIndex.vue?vue&type=script&lang=js"
export * from "./KlasusIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e65c82",
  null
  
)

export default component.exports